export enum ProviderType {
    Airwallex = 'airwallex',
    Wise = 'wise',
}
